module.exports = __webpack_public_path__ + "static/w_ford-d7bd0f34ef7fbb66e2c0bad422a73852.png";